export default __webpack_public_path__ + "images/39437c11b5f1d3a323080a19b4262fe6.svg";